module.exports = __webpack_public_path__ + "static/media/up-arrow.be7f6365.svg";